<template>
    <div>
        <div v-if="dados">
            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input :edicao="edicao" 
                        :sizing="sizing"
                        label="CEP" 
                        :rules="['size:8']"
                        :validate="validate"
                        type="cep" 
                        v-model="dados.in_cep" 
                        @change.native="buscarCep">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="dados.st_logradouro && !dados.in_cep && dados.cidade && !portal">
                                <button class="btn btn-outline-secondary" type="button" @click="buscarCepLogradouro()">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-6" v-if="!simples">
                    <az-input :edicao="edicao" label="Tipo de Logradouro" 
                        :sizing="sizing"
                        type="select" 
                        optionsMode="aql" 
                        service="tipo_logradouros.index" 
                        optionsData="id_tipo_logradouro" 
                        optionsDisplay="st_tipo_logradouro"
                        :validate="validate"
                        v-model="dados.id_tipo_logradouro" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input :edicao="edicao" label="Endereço" 
                        :sizing="sizing"
                        :validate="validate"
                        type="text" v-model="dados.st_logradouro">
                    </az-input>
                </div>
                <div class="col col-12 col-md-6">
                    <az-input :edicao="edicao" label="Complemento" 
                        :sizing="sizing"
                        :validate="validate"
                        type="text" v-model="dados.st_complemento" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input :edicao="edicao" label="Número" 
                        :sizing="sizing"
                        :validate="validate"
                        type="text" v-model="dados.st_numero" />
                </div>
                <div class="col col-12 col-md-6">
                    <az-input 
                        :edicao="edicao" 
                        label="Bairro" 
                        :sizing="sizing"
                        :validate="validate"
                        type="text" v-model="dados.st_bairro" />
                </div>
            </div>

            <div class="row" v-if="!simples">
                <div class="col col-12 col-md-6">
                    <az-input 
                        :edicao="edicao" 
                        label="UF" 
                        :sizing="sizing"
                        type="select" optionsMode="aql" 
                        service="estados.index" optionsData="id_estado" optionsDisplay="st_estado"
                        :validate="validate"
                        v-model="dados.id_estado"
                        @change.native="dados.cidade = null" />
                </div>
                <div class="col col-12 col-md-6">
                    <az-input :edicao="edicao" label="Cidade" 
                        :sizing="sizing"
                        type="autocomplete" 
                        optionsMode="aql" 
                        optionsDisplay="st_cidade"
                        service="cidades.index" 
                        :validate="validate"
                        :optionsParm="{ uf: dados.id_estado ? dados.id_estado : -1 }"
                        v-model="dados.cidade" />
                </div>
            </div>

            <div class="row mt-3" v-if="map_link">
                <div class="col col-12">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir_map_link()">
                                <i class="fas fa-map-marker-alt fa-fw"></i>
                            </button>
                        </div>
                        <input type="text" class="form-control" placeholder="Incluir link do Google Maps..." :value="dados.st_map_link" disabled>
                        <div class="input-group-append" v-if="dados.st_map_link">
                            <a :href="dados.st_map_link" class="btn btn-outline-primary" target="_blank">
                                <i class="fas fa-link"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="googleMapModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" v-if="map_link">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Link do Google Maps</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul>
                            <li>No computador, abra o <a href="https://www.google.com/maps" target="_blank">Google Maps</a>.</li>
                            <li>Encontre o endereço da unidade, que será utilizado para compatilhar a locaização.</li>
                            <li>Clique no menu do campo superior esquerdo: <i class="fas fa-bars"></i></li>
                            <li>Selecione a opção de compartilhar mapa. Se essa opção não estiver disponível, você ainda não selecionou o item no mapa.</li>
                            <li>Copie e cole o link no campo abaixo.</li>
                            <li>O link deve estar no formado https://goo.gl/maps/XXXXXXXXXXXXXXXXXX</li>
                        </ul>

                        <az-input 
                            label="Link"
                            v-model="dados.st_map_link" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        
        <!-- Buscar Cep Logradouro -->
        <div class="modal fade" id="buscaCepLogradouroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="pesquisar_cep">
                    <div class="modal-header">
                        <h5 class="modal-title">Buscar CEP</h5>
                        <button type="button" class="close" @click="fechar('buscaCepLogradouroModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            placeholder="Buscar por Logradouro..." 
                            v-model="pesquisa_logradouro" 
                            @onEnter="realizarBuscaCepLogradouro">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" @click="realizarBuscaCepLogradouro()" :disabled="$store.state.loading">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-loading v-if="$store.state.loading" />

                        <div v-if="resultado_pesquisa && resultado_pesquisa.resultado && resultado_pesquisa.resultado.length > 0" class="mt-3">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(cep, icx) in resultado_pesquisa.resultado" :key="icx" @click="selecionar_cep(cep)">
                                    <div class="lead">
                                        {{ cep.cep }} 
                                    </div>
                                    <div class="small">
                                        <div>{{ cep.logradouro }}</div>
                                        <div>{{ cep.bairro }}</div>
                                    </div>    
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('buscaCepLogradouroModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from './forms/AzInput.vue'
import AzLoading from '../util/AzLoading.vue';

export default {

    data () { 
        return {
            dados: null, 
            pesquisa_logradouro: "", 
            resultado_pesquisa: null, 
            pesquisar_cep: false, 
        }
    },

    props: { 
        edicao: { 
            type: Boolean,
            default: true 
        }, 
        value: { 
            type: null
        },
        validate: { 
            type: Boolean,
            default: false
        },
        map_link: { 
            type: Boolean,
            default: false
        },
        simples: { 
            type: Boolean,
            default: false
        },
        portal: { 
            type: Boolean,
            default: false
        },
        marcacao: { 
            type: Object,
            default: null
        },
        dominio: { 
            type: String,
            default: ""
        },
        token: { 
            type: String,
            default: ""
        },
        sizing: { 
            type: String,
            default: ""
        }
    },
        

    components: { 
        AzInput, 
        AzLoading
    },

    watch: {
        $props: {
            handler() {
                /*
                if ( !this.value ) { 
                    this.dados = { cidade: {} };    
                } else { 
                    if ( !this.value.cidade ) { 
                        this.value.cidade = {};
                    }
                    this.dados = this.value;
                }
                */
                this.dados = this.value;
            },
            deep: true,
            immediate: true,
        },
        dados: { 
            handler () { 
                this.$emit('input', this.dados);
            }
        }
    },

    methods: { 
        realizarBuscaCepLogradouro () { 
            this.resultado_pesquisa = [];

            this.$util.load(this, { 
                service: 'cep', 
                func: 'pesquisa',
                parms: { 
                    logradouro: this.pesquisa_logradouro, 
                    id_cidade: this.dados.cidade ? this.dados.cidade.id_cidade : null, 
                },
                loadTo: res => { 
                    this.resultado_pesquisa = res;
                }
            })
        },

        selecionar_cep (cep) { 
            this.dados.in_cep = cep.cep.replace(/\D/g, '');
            this.dados.st_logradouro = cep.logradouro;
            this.dados.st_bairro = cep.bairro;

            this.fechar('buscaCepLogradouroModal');
        },

        buscarCepLogradouro () { 
            this.pesquisar_cep = true; 
            this.resultado_pesquisa = [];
            this.pesquisa_logradouro = this.dados.st_logradouro || "";

            this.realizarBuscaCepLogradouro();

            this.$nextTick(() => { 
               $('#buscaCepLogradouroModal').modal('show');
            });
        },

        fechar(modal = 'googleMapModal') { 
            $('#' + modal).modal('hide');
        },

        incluir_map_link () { 
            $('#googleMapModal').modal('show');
        },

        buscarCep (event) { 

            if ( !event.target.value )
                return;

            if ( this.portal ) { 

                this.axios.post('portal/cep', { 
                        d: this.dominio,
                        m: this.marcacao.id_marcacao,
                        t: this.token,
                        cep: event.target.value, 
                    })
                    .then(res => { 
                        this.dados.st_logradouro = res.data.logradouro;
                        this.dados.st_bairro = res.data.bairro;

                        this.$forceUpdate ();
                    });

            } else { 

                this.$store.commit('loading', true);

                let query = { 
                                q: [ 
                                        { 
                                            name: 'cep.show', 
                                            parms: { cep: event.target.value }, 
                                            id: 'cep'
                                        }
                                    ]
                                };

                this.axios.post('aql', query)
                    .then (res => { 
                        if ( res.data.cep.status == 200 ) { 

                            this.dados.st_logradouro = res.data.cep.data.logradouro;
                            this.dados.st_bairro = res.data.cep.data.bairro;

                            if ( res.data.cep.data.cidade ) { 
                                this.dados.cidade = res.data.cep.data.cidade;
                                this.dados.id_estado = res.data.cep.data.cidade.id_estado;
                                this.id_estado = res.data.cep.data.cidade.id_estado;
                            }

                            this.$forceUpdate ();

                        }
                    })
                    .finally (() => { 
                        this.$store.commit('loading', false);
                    });

            }

        }
    }
    
}
</script>